import * as React from 'react';
import { render } from 'react-dom';
import { AuthButton, IUser } from '@action/auth-button';
import { ActionAuthButton, IAuthButtonConfig } from './utils/ActionAuthButton';

import authButtonStyles from './authButtonStyles.module.css';

// tslint:disable:no-any
const renderApp = (config: IAuthButtonConfig) => {
  const links = config.reglink || config.supportlink
    ? {
      registration: config.reglink,
      supportlink: config.supportlink,
    }
    : undefined;

  const userHandler = (user: IUser) => {
    (window as any).ActionAuthButton.setUser(user);
    config.onUserChange(user);
  };

  render(
    <AuthButton
      styles={authButtonStyles}
      user={config.user}
      appId={config.appid}
      productVersionIds={config.productVersionIds}
      emid={config.emid}
      links={links}
      lang={config.lang}
      theme={config.theme}
      env={config.mode}
      onUserChange={userHandler}
      text={config.text}
      placement={config.placement}
      feedback={config.feedback}
      setHandler={(window as any).ActionAuthButton.setHandler}
    />,
    document.getElementById('authButton'),
  );
};

const createAppContainer = (elementId: string) => {
  if (!elementId) {
    // eslint-disable-next-line no-console
    console.warn('Укажите блок для вставки -> config.loginblock');

    return;
  }

  const container = document.createElement('div');

  container.setAttribute('id', 'authButton');

  const targetContainer = document.getElementById(elementId);

  if (targetContainer) {
    targetContainer.appendChild(container);
  }
};

const initApp = (config: IAuthButtonConfig) => {
  createAppContainer(config.loginblock);
  renderApp(config);
};

/* ts-lint:disable */
(() => {
  (window as any).ActionAuthButton = new ActionAuthButton(initApp);
})();
/* ts-lint:enable */
